import { defineStore } from 'pinia';
import { httpAPI } from '@/services/ajax';
import { useAlertStore } from './alert';
import app from '@/main.js';

export const useAdminStore = defineStore('admin', {
    state: () => ({
        companyId: null,
        sectorId: null,
        allSectors: [],
        activeSectors: [],

        selectedSectorId: null,

        fetching: false,
        fetchPromise: null,
    }),
    actions: {
        setCompanyId(companyId) {
            this.companyId = companyId;
        },
        setSelectedSectorId(sectorId) {
            this.selectedSectorId = sectorId;
        },
        fetchSectors() {
            if (this.fetching && this.fetchPromise) {
                return this.fetchPromise;
            }
            this.fetching = true;
            const url =
                app.config.globalProperties.$env.apiRoot +
                'company/sector/read';
            const vm = this;
            this.fetchPromise = httpAPI(
                url,
                null,
                'GET',
                app.config.globalProperties.$router
            )
                .then((response) => {
                    if (response.success) {
                        vm.allSectors = response.data || [];
                        vm.activeSectors = vm.allSectors.filter(
                            (sector) => !sector?.archived
                        );
                    } else {
                        const alertStore = useAlertStore();
                        alertStore.pushError(
                            'Failed to fetch sectors: ' + response?.message
                        );
                    }
                    return vm.allSectors;
                })
                .finally(() => {
                    vm.fetching = false;
                    vm.fetchPromise = null;
                });
            return this.fetchPromise;
        },
        syncSectors() {
            if (this.allSectors && this.allSectors.length > 0) {
                return Promise.resolve(this.allSectors);
            }
            return this.fetchSectors();
        },
    },
    getters: {
        getSectorsOptions(state) {
            return state.allSectors.map((sector) => ({
                text: sector.name + (sector?.archived ? ' (Archived)' : ''),
                value: sector.id,
            }));
        },
    },
});
